module.exports = __webpack_public_path__ + "static/img/locker-gray.b4ee17ed.svg";